import { useContext, useEffect, useState } from 'react'
import './HydrologistBoss.scss'
import { HydrologistBossContext } from './hooks/useHydrologistBoss'
import { HydrologistSelect } from '../../utils/HydrologistSelect/HydrologistSelect'
import { HydrologistInput } from '../../utils/HydrologistInput/HydrologistInput'
import { getHydrologistDataMonthDate } from '../Hydrologist_worker/http/HyderologistWorkerHttp'
import { getDaysInMonth } from '../../utils/utils'
import AuthContext from '../../../../context/AuthContext'
import { HydrologistBossTable } from './components/HydrologistBossTable/HydrologistBossTable'

export const HydrologistBoss = () => {

  const { authTokens } = useContext(AuthContext);

  let {
    memoizedWps,
    memoizedDate,
    memoizedWells
  } = useContext(HydrologistBossContext)

  const [tableData, setTableData] = useState([]);
  const [datesInMonth, setDatesInMonth] = useState([])

  useEffect(() => {
    if (memoizedDate?.selectedDate && memoizedWells?.selectedWell) {
      getHydrologistDataMonthDate(authTokens, memoizedDate?.selectedDate, memoizedWells?.selectedWell, setTableData, datesInMonth)
    }
  }, [memoizedDate?.selectedDate, memoizedWells?.selectedWell, datesInMonth])

  useEffect(() => {
    getDaysInMonth(memoizedDate?.selectedDate, setDatesInMonth)
  }, [memoizedDate?.selectedDate])

  return (
    <div className="hydrologistBoss">
      <div className="container">
        <form className='hydrologistBoss-form'>
          <HydrologistSelect
            name={"Выберите ВЗУ"}
            list={memoizedWps?.wps}
            value={'id'}
            visible_value={'name'}
            getter={memoizedWps?.selectedWps}
            setter={memoizedWps?.setSelectedWps}
            parse={'int'}
          />
          {memoizedWells?.selectedWell &&
            <>
              <HydrologistSelect
                name={"Выберите скважину"}
                list={memoizedWells?.wells}
                value={'id'}
                visible_value={'number_well'}
                secondVisibleName={'status'}
                getter={memoizedWells?.selectedWell}
                setter={memoizedWells?.setSelectedWell}
                parse={'int'}
              />
              <HydrologistInput
                type='date'
                title='Выберите дату'
                name='selectDate'
                setter={memoizedDate?.setSelectedDate}
                getter={memoizedDate?.selectedDate}
                value={memoizedDate?.selectedDate}
                required={true}
              />
            </>}
        </form>
        {memoizedWells?.selectedWell &&
          <HydrologistBossTable data={tableData} actions />
        }

      </div>
    </div>
  )

}